import React from "react";
import FormTextBox from "../yoello-lib/modules/dynamicForms/FormComponents/FormTextBox";
import IDynamicFormRow from "../yoello-lib/modules/dynamicForms/interfaces/IDynamicFormRow";


export const resetPasswordFormRows = (
  t: (key: string) => string
): IDynamicFormRow[] => {
  const forgottenPassword = () => (
    <p>{t("forms.resetPassword.forgottenDescription")}</p>
  );

  return [
    {
      label: "forms.resetPassword.forgottenLabel",
      Component: forgottenPassword,
      keyName: "forgotten",
    },
    {
      label: "forms.resetPassword.email",
      keyName: "email",
      Component: FormTextBox,
      inputProperties: {
        type: "email",
      },
      registerOptions: { required: true },
    },
  ];
};
